export function parseJwt(token) {
  const base64Url = token.split('.')[1]
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split('')
      .map((char) => `%${`00${char.charCodeAt(0).toString(16)}`.slice(-2)}`)
      .join('')
  )
  return JSON.parse(jsonPayload)
}

export function isTokenExpired(token) {
  if (!token) return true
  try {
    const payload = parseJwt(token)
    return payload.exp < Date.now() / 1000
  } catch {
    return true
  }
}
